import { useMediaQuery } from './use-media-query';

// 모바일 반응형 키트 — 1단계(전역 기본기).
//
// 배경(docs/plan/windows-responsive-mobile-2026-07): 이 콘솔은 인라인 style 이
// 압도적이라 CSS @media 가 거의 닿지 않는다. 그래서 breakpoint 는 JS(useMediaQuery)
// 로 다룬다. 문제는 지금까지 breakpoint 문자열이 페이지마다 하드코딩돼(예:
// InfrastructurePage 의 '(max-width: 960px)') 재발명되고 있다는 것 — 이 파일이
// 그 단일 진실원이다. 새 페이지는 여기 훅만 쓰면 반응형이 "공짜로" 따라온다.
//
// 경계값 근거:
//   - MOBILE(<=640): 폰 세로. 사이드바를 햄버거로, 표를 스크롤/카드로.
//   - TABLET(<=960): 폰 가로 ~ 좁은 태블릿. 기존 InfrastructurePage 가 쓰던 값 계승.
export const BREAKPOINTS = {
  mobile: 640,
  tablet: 960,
} as const;

/** 폰 세로 폭(<=640px). 사이드바 햄버거화·표 처리의 주 기준. */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.mobile}px)`);
}

/** 좁은 화면(<=960px). 2열→1열 그리드 접기 등 중간 단계. */
export function useIsNarrow(): boolean {
  return useMediaQuery(`(max-width: ${BREAKPOINTS.tablet}px)`);
}
